import { Box } from '@chakra-ui/react';
import { CountdownTimer } from '@diamond/shared/ui';
import Link from 'next/link';
import { memo } from 'react';

import { PaymentActionsProps } from './types';

const PaymentActions = memo(
  ({ data, selectedShipToId, isMobile }: PaymentActionsProps) => {
    if (data.status !== 'waiting_for_payment') {
      return null;
    }

    const uploadLink = `/order-detail/${data.order_meta_id}?warehouse=${selectedShipToId}#submit-payment-proof`;

    if (isMobile) {
      return (
        <Box
          w="full"
          display="flex"
          justifyContent="center"
          textAlign="center"
          gap="2.5"
          my="2"
          mb="4"
        >
          <Box
            as={Link}
            fontSize="xs"
            color="blue"
            whiteSpace="nowrap"
            textDecoration="underline"
            fontWeight="600"
            href={uploadLink}
          >
            Unggah Bukti Transfer
          </Box>
          {data.expired_at && <CountdownTimer endTime={data.expired_at} />}
        </Box>
      );
    }

    return (
      <Box
        display="flex"
        flexDir="row"
        alignItems="center"
        justifyContent="center"
        gap="2.5"
        w="full"
      >
        <Box
          as={Link}
          fontSize="md"
          color="blue"
          whiteSpace="nowrap"
          textDecoration="underline"
          fontWeight="600"
          href={uploadLink}
        >
          Unggah Bukti Transfer
        </Box>
        {data.expired_at && <CountdownTimer endTime={data.expired_at} />}
      </Box>
    );
  }
);

PaymentActions.displayName = 'PaymentActions';

export { PaymentActions };
